import styled from 'styled-components';
import { IonGrid } from '@ionic/react';

export const IonGridWrapper = styled(IonGrid)``;
